import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { textSecondary, white } from "../../utils/colors";
import useThemeColors from "../../hooks/useThemeColors";

const MonthlyItem = ({ itemKey, left, right, isPrice }) => {
  // COLORS
  const { whiteMode, newBorderMode, textPrimaryMode } = useThemeColors();

  return (
    <Flex
      key={itemKey}
      align="center"
      justify="space-between"
      bg={whiteMode}
      borderTop={`1px solid ${newBorderMode}`}
      borderRadius="0rem"
      p="0.5rem 0rem"
    >
      <Flex align="center">
        <Text
          fontSize="0.8rem"
          fontWeight="500"
          color={textSecondary}
          textTransform="capitalize"
        >
          {left}
        </Text>
      </Flex>
      <Flex align="center" justify="flex-end" gap="3rem">
        <Flex fontSize="0.8rem" color={textPrimaryMode} fontWeight="500">
          {right}
          {/* {isPrice && (
            <Text as="span" ml="0.25rem">
              €
            </Text>
          )} */}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MonthlyItem;
